import { cn } from 'lib/utils'
import type { ListCardProps } from './types'
import { CardHeader, CARD_BASE_CLASS } from '../shared'

import './index.scss'

const mainClass = 'card-list'

export const ListCardVariant = ({
  title,
  image,
  list = [],
  modifier,
}: ListCardProps) => {
  return (
    <div className={cn(mainClass, modifier, CARD_BASE_CLASS)}>
      <CardHeader title={title} image={image} mainClass={mainClass} />
      {list?.length > 0 && (
        <div className={`${mainClass}__content`}>
          <ul>
            {list?.map((item, index) => (
              <li key={`${item}-${index}`}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
